<!-- what does the newprofile and newuser do for social -->
<template>
  <v-container fluid class="ma-3">
    <v-row>
    <v-card flat outlined class="d-inline-block mr-3" id="friend-card" v-for="social in socials" :key="social.friendId" >
      <!-- row 1: image and name -->
      <v-row class="mt-n3">
        <v-col cols="auto">
           <v-img
          id="friend-photo"
          height="200"
          width="200"
          :src="newProfile(social.friendId).profilePic"
          v-if="social.me === true && newProfile(social.friendId).profilePic"
          ></v-img>

          <v-img
          id="friend-photo"
          height="200"
          width="200"
          src="https://wallpapercave.com/wp/IooPgL8.jpg"
          v-if="social.me === true && newProfile(social.friendId).profilePic === ''"
          ></v-img>

          <v-card-text style="word-wrap: break-word; width: 200px" class="headline text-truncate" v-if="social.me === true">{{ newUser(social.friendId) }}</v-card-text>
          <v-card-text  style="word-wrap: break-word; width: 200px" class="text-truncate" color="grey" v-if="social.me === true">{{newProfile(social.friendId).bio}}</v-card-text>
        </v-col>


        <!-- 2nd column, row is a flex column going down -->
        <v-col
        cols="auto"
        class="text-center pl-0"
        >
        <v-row
        class="flex-column ma-0"
        justify="center"
        >
        <v-col class="px-0">
          <v-btn icon :to="'/profile/' + social.friendId" v-if="social.me === true">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </v-col>

        <v-col class="px-0">
          <v-btn icon :to="'/messages/' + social.friendId" v-if="social.me === true">
            <v-icon>mdi-chat</v-icon>
          </v-btn>
        </v-col>


      </v-row>
    </v-col>

  </v-row>
</v-card>

 <v-card flat outlined class="d-inline-block mr-3" id="friend-card" v-for="group in groups" :key="group.chatId" >
      <!-- row 1: image and name -->
      <v-row class="mt-n3"  >
        <v-col cols="auto">
          <v-img
          id="friend-photo"
          height="200"
          width="200"
          :src="group.imageUrl"
          ></v-img>

          <v-card-text style="word-wrap: break-word; width: 200px" class="headline text-truncate" >{{ group.name }}</v-card-text>
          <v-card-text color="grey"  >Group Chat</v-card-text>
        </v-col>


        <!-- 2nd column, row is a flex column going down -->
        <v-col
        cols="auto"
        class="text-center pl-0"
        >
        <v-row
        class="flex-column ma-0"
        justify="center"
        >

        <v-col class="px-0">
          <v-btn icon :to="'/group-chat/' + group.chatId"  >
            <v-icon>mdi-chat</v-icon>
          </v-btn>
        </v-col>


      </v-row>
    </v-col>

  </v-row>
</v-card>
</v-row>
</v-container>



</template>


<script>
export default {
  computed: {
    socials() {
      return this.$store.getters.friends
    },
    groups(){
      return this.$store.getters.groupchat
    }
  },
  methods: {
    onLoadFriend(friendid){
      this.$router.push('/profile/' + friendid)
    },
    newUser(social) {
      return this.$store.state.allUsers[social].username
    },
    newProfile(social) {
      return this.$store.state.allUsers[social]
    },
    getMembers(social) {
      this.$store.dispatch('firebaseGetGroupMembers', social)
      return true
    },
    accepted() {
      return this.$store.state.groupMembers[this.$store.state.user.id].member
    }
  },
  mounted() {
    this.$store.dispatch('firebaseGetFriends')
    this.$store.dispatch('firebaseGetGroupChat')
     this.$store.dispatch('firebaseGetDMs')
     this.$store.dispatch('firebaseGetNotifications')
    this.$store.state.fetchGroupMessages= {}
  }

}
</script>

<style lang="css" scoped>
#friend-card {
  border-radius: 20px;
}

#friend-photo {
  border-radius: 20px 0 5px 0;
}

</style>
